import { render, staticRenderFns } from "./LifekeyPopup.vue?vue&type=template&id=31da5728&scoped=true&"
import script from "./LifekeyPopup.vue?vue&type=script&lang=js&"
export * from "./LifekeyPopup.vue?vue&type=script&lang=js&"
import style0 from "./LifekeyPopup.vue?vue&type=style&index=0&id=31da5728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da5728",
  null
  
)

/* custom blocks */
import block0 from "./LifekeyPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports